import { AdminLocation, AdminSalesPerson, AdminSalesSupportPerson, AdminUser, Company } from "src/api-service";

export interface InternalUsersLoadingState {
    loading: boolean;
    saving: boolean;
    deleting: boolean;
}

export interface InternalUsersState {
    users: AdminUser[];
    companies: Company[];
    salesPersonsByEmail: Record<string, AdminSalesPerson>;
    salesSupportByEmail: Record<string, AdminSalesSupportPerson>;
    salesPersonLocations: AdminLocation[];
    loaded: boolean;
    loading: InternalUsersLoadingState;
}

export const initialInternalUsersState: InternalUsersState = {
    users: [],
    companies: [],
    salesPersonsByEmail: {},
    salesSupportByEmail: {},
    salesPersonLocations: [],
    loaded: false,
    loading: { loading: false, saving: false, deleting: false },
};
